import { render } from "./StudbookPrintView.vue?vue&type=template&id=2c116d23"
import script from "./StudbookPrintView.vue?vue&type=script&lang=js"
export * from "./StudbookPrintView.vue?vue&type=script&lang=js"

import "./StudbookPrintView.vue?vue&type=style&index=0&id=2c116d23&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__